module.exports = __webpack_public_path__ + "img/7_3.5ab2fa98.png";